import { useDashboardFilters } from '@/contexts/DashboardStateContext';
import { PagePost, PageSection } from '@gettactic/api';

import { PageGrid } from './site-info/PageCard';
import { SectionCard } from './site-info/SectionCard';
import { PageCardGrid } from './site-info/PageCardGrid';
import { PageTitleAndDesc } from './site-info/PageTitleAndDesc';
import { InfoPageIcon } from '@cmp-src/icons/IconFromSet/InfoPageIcon';

export const SectionContent = ({
  section,
  subSections,
  pages
}: { pages: PagePost[]; section: PageSection; subSections: PageSection[] }) => {
  const { setSelectedPageId, setSelectedSectionId } = useDashboardFilters();

  const goToPage = (page: PagePost) => {
    setSelectedPageId(page.id);
  };

  const isPageClickable = (page: PagePost) => {
    return page.content && page.content.length > 0;
  };

  const handlePageClick = (page: PagePost) => {
    if (isPageClickable(page)) {
      goToPage(page);
    }
  };

  const handleSectionClick = (sectionId: string) => {
    setSelectedSectionId(sectionId);
  };

  const parsedImage = section.image_url ? JSON.parse(section.image_url) : null;
  let icon = null;
  if (typeof parsedImage === 'object') {
    icon = parsedImage;
  }

  return (
    <>
      <PageTitleAndDesc
        title={section?.name || ''}
        description={section.description || ''}
        icon={<InfoPageIcon image_url={section.image_url} />}
      />
      <div className="flex flex-col gap-4">
        {subSections.length > 0 && (
          <PageCardGrid>
            {subSections.map((subSection) => (
              <SectionCard
                key={subSection.id}
                section={subSection}
                onClick={() => handleSectionClick(subSection.id)}
              />
            ))}
          </PageCardGrid>
        )}

        {pages.length > 0 && (
          <PageGrid pages={pages} onPageClick={handlePageClick} />
        )}
      </div>
      {subSections.length === 0 && pages.length === 0 && (
        <div className="mt-8 rounded-lg border-2 border-gray-300 border-dashed p-12 text-center text-gray-500">
          <h3 className="font-medium text-xl">No content</h3>
          <p className="mt-2">
            There are no sub-sections or pages in this section.
          </p>
        </div>
      )}
    </>
  );
};
